export const updateClientTablePagination = (previous, selection) => ({
  current:
    previous.pageSize === selection.pageSize ? selection.current : 1,
  pageSize: selection.pageSize
})
